import React from 'react';
import { Flex, Text, Checkbox } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

function SimpleCheckbox({ name, text }) {
  const methods = useFormContext();

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field: { onChange, value } }) => {
        const curatedValue = value ?? false;

        return (
          <Flex width='100%'>
            <Checkbox isChecked={curatedValue} onChange={e => onChange(e.target.checked)} mr={2} marginLeft='20px'>
              <Text fontSize='14px'>{text}</Text>
            </Checkbox>
          </Flex>
        );
      }}
    />
  );
}

export default SimpleCheckbox;
